import { Dialog, DialogChainObject } from "quasar"
import { i18n } from "src/boot/i18n"
import SfxDialogAuthenticationError from "src/components/dialogs/error/SfxDialogAuthenticationError.vue"
import SfxDialogNoWorkspaces from "src/components/dialogs/error/SfxDialogNoWorkspaces.vue"
import SfxDialogOffline from "src/components/dialogs/error/SfxDialogOffline.vue"
import SfxDialogHttp400 from "src/components/dialogs/http/SfxDialogHttp400.vue"
import SfxDialogHttp401 from "src/components/dialogs/http/SfxDialogHttp401.vue"
import SfxDialogHttp403 from "src/components/dialogs/http/SfxDialogHttp403.vue"
import SfxDialogHttp404 from "src/components/dialogs/http/SfxDialogHttp404.vue"
import SfxDialogHttp408 from "src/components/dialogs/http/SfxDialogHttp408.vue"
import SfxDialogHttp500 from "src/components/dialogs/http/SfxDialogHttp500.vue"
import SfxDialogHttp501 from "src/components/dialogs/http/SfxDialogHttp501.vue"
import SfxDialogHttp502 from "src/components/dialogs/http/SfxDialogHttp502.vue"
import SfxDialogHttp503 from "src/components/dialogs/http/SfxDialogHttp503.vue"
import SfxDialogHttp504 from "src/components/dialogs/http/SfxDialogHttp504.vue"
import SfxDialogListAttachmentDelete from "src/components/dialogs/list/SfxDialogListAttachmentDelete.vue"
import SfxDialogListAttachmentSelect from "src/components/dialogs/list/SfxDialogListAttachmentSelect.vue"
import SfxDialogListIdentifier from "src/components/dialogs/list/SfxDialogListIdentifier.vue"
import SfxDialogListIssue from "src/components/dialogs/list/SfxDialogListIssue.vue"
import SfxDialogListIssueManager from "src/components/dialogs/list/SfxDialogListIssueManager.vue"
import SfxDialogListUnsubmittedWork from "src/components/dialogs/list/SfxDialogListUnsubmittedWork.vue"
import SfxDialogListUnsubmittedWorkIssues from "src/components/dialogs/list/SfxDialogListUnsubmittedWorkIssues.vue"
import SfxDialogListWorkOrder from "src/components/dialogs/list/SfxDialogListWorkOrder.vue"
import SfxDialogListWorkOrderSelect from "src/components/dialogs/list/SfxDialogListWorkOrderSelect.vue"
import SfxDialogAcceptCorrectiveWork from "src/components/dialogs/SfxDialogAcceptCorrectiveWork.vue"
import SfxDialogAddAttachments from "src/components/dialogs/SfxDialogAddAttachments.vue"
import SfxDialogAddComment from "src/components/dialogs/SfxDialogAddComment.vue"
import SfxDialogAttachmentDetails from "src/components/dialogs/SfxDialogAttachmentDetails.vue"
import SfxDialogChangePassword from "src/components/dialogs/SfxDialogChangePassword.vue"
import SfxDialogChangeUnlockKey from "src/components/dialogs/SfxDialogChangeUnlockKey.vue"
import SfxDialogCheckBox from "src/components/dialogs/SfxDialogCheckBox.vue"
import SfxDialogConfirmation from "src/components/dialogs/SfxDialogConfirmation.vue"
import ConnectVueDevtools from "src/components/dialogs/SfxDialogConnectVueDevtools.vue"
import SfxDialogDataFetch from "src/components/dialogs/SfxDialogDataFetch.vue"
import SfxDialogDevicePermission from "src/components/dialogs/SfxDialogDevicePermission.vue"
import SfxDialogEditCorrectionInfo from "src/components/dialogs/SfxDialogEditCorrectionInfo.vue"
import SfxDialogFeedback from "src/components/dialogs/SfxDialogFeedback.vue"
import SfxDialogFilterItems from "src/components/dialogs/SfxDialogFilterItems.vue"
import SfxDialogIdentifierExists from "src/components/dialogs/SfxDialogIdentifierExists.vue"
import SfxDialogIdentifierUnknown from "src/components/dialogs/SfxDialogIdentifierUnknown.vue"
import SfxDialogImageDelete from "src/components/dialogs/SfxDialogImageDelete.vue"
import SfxDialogInput from "src/components/dialogs/SfxDialogInput.vue"
import SfxDialogItemClone from "src/components/dialogs/SfxDialogItemClone.vue"
import SfxDialogMessage from "src/components/dialogs/SfxDialogMessage.vue"
import SfxDialogRejectedCorrectiveWork from "src/components/dialogs/SfxDialogRejectedCorrectiveWork.vue"
import SfxDialogRejectPerformedWork from "src/components/dialogs/SfxDialogRejectPerformedWork.vue"
import SfxDialogRemoveIssueFromWorkOrder from "src/components/dialogs/SfxDialogRemoveIssueFromWorkOrder.vue"
import SfxDialogRemoveItemFromWorkOrder from "src/components/dialogs/SfxDialogRemoveItemFromWorkOrder.vue"
import SfxDialogSelectModel from "src/components/dialogs/SfxDialogSelectModel.vue"
import SfxDialogSystemNotification from "src/components/dialogs/SfxDialogSystemNotification.vue"
import SfxDialogTableConfigurations from "src/components/dialogs/SfxDialogTableConfigurations.vue"
import SfxDialogToDoDelete from "src/components/dialogs/SfxDialogToDoDelete.vue"
import SfxDialogUndoNotification from "src/components/dialogs/SfxDialogUndoNotification.vue"
import SfxDialogUnsubmittedIssues from "src/components/dialogs/SfxDialogUnsubmittedIssues.vue"
import SfxDialogUserSettings from "src/components/dialogs/SfxDialogUserSettings.vue"
import SfxDialogWarning from "src/components/dialogs/SfxDialogWarning.vue"
import SfxDialogWorkOrderEntities from "src/components/dialogs/SfxDialogWorkOrderEntities.vue"
import SfxDialogWorkOrderRemoveIssue from "src/components/dialogs/SfxDialogWorkOrderRemoveIssue.vue"
import SfxDialogWorkOrderRemoveItem from "src/components/dialogs/SfxDialogWorkOrderRemoveItem.vue"
import { LABELS } from "src/env/labels"
import { FeedbackType, useSupportStore } from "src/stores/supportStore"
import { useUserStore } from "src/stores/userStore"
import { SfxDialogCheckedAndInput } from "src/util/types/components/sfxDialogCheckedAndInput"
import { ImageViewerItem } from "src/util/types/components/sfxImageGallery"
import { SearchInColumn } from "src/util/types/components/sfxTable"
import { Attachment, AttachmentContext } from "src/util/types/dataModels/attachment"
import { EntityPages } from "src/util/types/dataModels/entityDefinition"
import { AssociationType, PayloadEntity } from "src/util/types/dataModels/genericObject"
import {
  IdentifierActionReturn,
  IdentifierAdd,
  IdentifierAssociationType,
  IdentifierRemove,
} from "src/util/types/dataModels/identifier"
import {
  Issue,
  IssueAssociationType,
  IssueCardData,
  IssueCorrectiveWorkRejectedEventCard,
  IssueEntity,
  IssuesOnItem,
  IssuesOnItemAction,
  OperationsOnIssue,
} from "src/util/types/dataModels/issue"
import { IssueComment } from "src/util/types/dataModels/issueComment"
import { ItemCardData } from "src/util/types/dataModels/item"
import { PerformedWorkComment } from "src/util/types/dataModels/performedWork"
import {
  UnsubmittedWorkEntity,
  UnsubmittedWorkWithEntity,
} from "src/util/types/dataModels/unsubmittedWork"
import { WorkOrderCardData } from "src/util/types/dataModels/workOrder"
import {
  WorkOrderCorrectiveItemComment,
  WorkOrderRegularItemComment,
} from "src/util/types/dataModels/workOrderComment"
import {
  CheckBoxDialogOptions,
  CommonDialogOptions,
  ConfirmationDialogOptions,
  InputDialogOptions,
  MessageDialogOptions,
} from "src/util/types/dialogs"
import { SystemNotificationCardData } from "src/util/types/notifications"
import { Component } from "vue"
import SfxDialogFilterIssues from "src/components/dialogs/SfxDialogFilterIssues.vue"
import SfxDialogFilterWorkOrders from "src/components/dialogs/SfxDialogFilterWorkOrders.vue"
import SfxDialogFilterPerformedWork from "src/components/dialogs/SfxDialogFilterPerformedWork.vue"
import SfxDialogFilterTecModeIssues from "src/components/dialogs/SfxDialogFilterTecModeIssues.vue"
import SfxDialogFilterTecModeWorkOrders from "src/components/dialogs/SfxDialogFilterTecModeWorkOrders.vue"
import SfxDialogFilterTecModePerformedWork from "src/components/dialogs/SfxDialogFilterTecModePerformedWork.vue"
import SfxDialogFilterTecModeItemClasses from "src/components/dialogs/SfxDialogFilterTecModeItemClasses.vue"

//region Helpers
/**
 * Promisifies a {@link DialogChainObject} to resolve with:
 * - `true` on dialog OK
 * - `false` on dialog cancel/dismiss.
 *
 * @param chainObject The chain object to handle events from
 */
async function promisifyDialogChainObject(
  chainObject: DialogChainObject
): Promise<boolean | undefined> {
  return new Promise((resolve) => {
    chainObject
      .onOk(() => {
        resolve(true)
      })
      .onCancel(() => {
        resolve(false)
      })
  })
}

/**
 * Generically create a dialog with {@link CommonDialogOptions}.
 *
 * @param component to create dialog with.
 * @param options (props) to apply to component.
 */
function genericCommonDialogCreator<OptionsType extends CommonDialogOptions>(
  component: Component,
  options: OptionsType | Record<string, never> = {}
): DialogChainObject {
  options.html = options.html ?? false

  return Dialog.create({
    component: component,
    componentProps: options,
  })
}

//endregion

//region Standard dialogs

/**
 * Shows a dialog that displays a message.
 *
 * @param options that correspond with the props of {@link SfxDialogMessage} *
 * @return The returned promise resolves with `true` if OK was pressed, and `false ` the dialog was dismissed any other way.
 */
export async function messageDialog(options: MessageDialogOptions): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogMessage, options))
}

/**
 * Shows a dialog that displays device permission information.
 *
 * @return The returned promise resolves with `true` if OK was pressed, and `false ` the dialog was dismissed any other way.
 */
export async function permissionDialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogDevicePermission))
}

/**
 * Shows a confirmation dialog, where the user can choose to confirm or not.
 * The dialog is conveniently wrapped in a promise.
 *
 * @param options that correspond with the props of {@link SfxDialogConfirmation}
 * @return The returned promise resolves with `true` if confirmed, and `false ` if not.
 */
export async function confirmationDialog(
  options: ConfirmationDialogOptions
): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogConfirmation, options))
}

/**
 * Shows an input dialog, where the user can input a string.
 * The dialog is conveniently wrapped in a promise.
 *
 * @param options that correspond with the props of {@link SfxDialogInput}
 * @return The returned promise resolves with a string or `undefined`
 */
export async function inputDialog(options: InputDialogOptions): Promise<string | null> {
  return new Promise((resolve) =>
    genericCommonDialogCreator(SfxDialogInput, options)
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

/**
 * Shows a dialog with a check box
 *
 * @param options Correspond with the props of {@link SfxDialogCheckBox}
 * @return The returned promise resolves with a boolean or null
 */
export async function checkBoxDialog(options: CheckBoxDialogOptions): Promise<boolean | null> {
  return new Promise((resolve) =>
    genericCommonDialogCreator(SfxDialogCheckBox, options)
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export async function unsavedChangesDialog() {
  const { t } = i18n.global

  const confirmationDialogOption: ConfirmationDialogOptions = {
    title: t("sfxDialogUnsavedChanges.title"),
    content: t("sfxDialogUnsavedChanges.content"),
    confirmButtonText: t("sfxButtons.btn_continue"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
  }

  return await confirmationDialog(confirmationDialogOption)
}

export async function proofOfPresenceRequiredDialog(entityType: IdentifierAssociationType) {
  const { t } = i18n.global

  let entity

  switch (entityType) {
    case "area":
      entity = t("entity.area")
      break

    case "item":
      entity = t("entity.item")
      break

    case "location":
      entity = t("entity.location")
      break
  }

  const confirmationDialogOption: ConfirmationDialogOptions = {
    title: t("sfxDialogProofOfPresence.title"),
    content: t("sfxDialogProofOfPresence.content", { entity }),
    confirmButtonText: t("sfxButtons.btn_open_identify"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    html: true,
  }

  return await confirmationDialog(confirmationDialogOption)
}

export async function wrongIdentifierDialog() {
  const { t } = i18n.global

  const messageDialogOptions: MessageDialogOptions = {
    title: t("sfxDialogWrongIdentifier.title"),
    content: t("sfxDialogWrongIdentifier.content"),
    buttonText: t("sfxButtons.btn_understood_without_exclamation"),
    html: true,
  }

  return messageDialog(messageDialogOptions)
}

//endregion

//region Special dialogs

export function connectVueDevtoolsDialog() {
  Dialog.create({ component: ConnectVueDevtools })
}

export async function systemDialog(props: SystemNotificationCardData) {
  return promisifyDialogChainObject(
    Dialog.create({ component: SfxDialogSystemNotification, componentProps: props })
  )
}

export function todoDeleteAllDialog(amount: number) {
  return Dialog.create({ component: SfxDialogToDoDelete, componentProps: { amount } })
}

export function tableConfigurationsDialog(
  visibleColumns: string[],
  filterTerm: string,
  entity: string,
  searchInColumn?: SearchInColumn
): Promise<number | null> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogTableConfigurations,
      componentProps: { visibleColumns, filterTerm, entity, searchInColumn },
    })
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export function filterTecModeIssuesDialog() {
  Dialog.create({
    component: SfxDialogFilterTecModeIssues,
  })
}

export function filterTecModeWorkOrdersDialog() {
  Dialog.create({
    component: SfxDialogFilterTecModeWorkOrders,
  })
}

export function filterTecModePerformedWorkDialog() {
  Dialog.create({
    component: SfxDialogFilterTecModePerformedWork,
  })
}

export function filterItemsDialog(entityForWorkOrderPage?: boolean) {
  Dialog.create({
    component: SfxDialogFilterItems,
    componentProps: {
      entityForWorkOrderPage,
    },
  })
}

export function filterIssuesDialog(entityForWorkOrderPage?: boolean) {
  Dialog.create({
    component: SfxDialogFilterIssues,
    componentProps: {
      entityForWorkOrderPage,
    },
  })
}

export function filterWorkOrdersDialog() {
  Dialog.create({
    component: SfxDialogFilterWorkOrders,
  })
}

export function filterPerformedWorkDialog() {
  Dialog.create({
    component: SfxDialogFilterPerformedWork,
  })
}

export function filterTecModeItemClassDialog(itemClassIds?: string[]): Promise<string[] | null> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogFilterTecModeItemClasses,
      componentProps: {
        itemClassIds,
      },
    })
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

function changeRequestForRemoval(title: string) {
  const { t } = i18n.global

  const dialogOptions: InputDialogOptions = {
    title,
    content: t("sfxDialogChangeRequest.content"),
    label: t("sfxDialogChangeRequest.label"),
    confirmButtonText: t("sfxButtons.btn_request_removal"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    confirmButtonClasses: "bg-negative text-white",
    inputRequired: true,
  }

  return inputDialog(dialogOptions)
}

export function deleteAttachment() {
  const { t } = i18n.global
  const title = t("sfxDialogChangeRequest.title_attachment")

  return changeRequestForRemoval(title)
}

export function deleteImage() {
  const { t } = i18n.global
  const title = t("sfxDialogChangeRequest.title_image")

  return changeRequestForRemoval(title)
}

export function selectModel(itemName: string, modelName: string, showHint = true) {
  return Dialog.create({
    component: SfxDialogSelectModel,
    componentProps: { itemName, modelName, showHint },
  })
}

export async function unknownIdentifierDialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogIdentifierUnknown))
}

export async function alreadyAssociatedIdentifierDialog(
  entityOldType: IdentifierAssociationType,
  entityOldName: string,
  entityNewType: IdentifierAssociationType,
  entityNewName: string
): Promise<boolean | undefined> {
  return promisifyDialogChainObject(
    Dialog.create({
      component: SfxDialogIdentifierExists,
      componentProps: {
        entityOldType,
        entityOldName,
        entityNewType,
        entityNewName,
      },
    })
  )
}

export function itemCloneDialog(item: ItemCardData) {
  return promisifyDialogChainObject(
    Dialog.create({
      component: SfxDialogItemClone,
      componentProps: { item },
    })
  )
}

export function stagnantWorkDialog(days: number) {
  const { t } = i18n.global
  const title = t("sfxDialogStagnantWork.title")
  const content = t("sfxDialogStagnantWork.content", { days })
  const buttonText = t("sfxButtons.btn_understood")

  return messageDialog({ title, content, buttonText, html: true, persistent: true })
}

export async function discardUnsubmittedWorkDialog(
  confirmDialogText: string[]
): Promise<boolean | undefined> {
  const confirmationDialogOption: ConfirmationDialogOptions = {
    title: confirmDialogText[0],
    content: confirmDialogText[1],
  }
  return confirmationDialog(confirmationDialogOption)
}

export async function warningDialog(
  title: string,
  bodyContent: string[],
  confirmButtonText?: string,
  rejectButtonText?: string
): Promise<boolean | undefined> {
  return promisifyDialogChainObject(
    Dialog.create({
      component: SfxDialogWarning,
      componentProps: { title, bodyContent, confirmButtonText, rejectButtonText },
    })
  )
}

export async function discardWorkDialog(): Promise<boolean | undefined> {
  const { t } = i18n.global
  const title = t("sfxDialogDiscardWork.title")
  const content = t("sfxDialogDiscardWork.content")

  return confirmationDialog({ title: title, content: content, html: true })
}

export async function dataFetchDialog(workspaceId: string): Promise<boolean | undefined> {
  return new Promise((resolve) => {
    Dialog.create({ component: SfxDialogDataFetch, componentProps: { workspaceId } }).onOk(
      (result: boolean) => {
        resolve(result)
      }
    )
  })
}

export async function attachmentDetailsDialog(
  entity: string, // Translated entity
  attachment: Attachment
): Promise<string | null> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogAttachmentDetails,
      componentProps: { entity, attachment },
    })
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export async function addAttachmentsDialog(): Promise<number | null> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogAddAttachments,
    })
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export async function imageDeleteDialog(
  entity: string,
  image: ImageViewerItem
): Promise<boolean | undefined> {
  return promisifyDialogChainObject(
    Dialog.create({
      component: SfxDialogImageDelete,
      componentProps: { entity, image },
    })
  )
}

export function unsubmittedIssuesDialog(amount: number) {
  return Dialog.create({ component: SfxDialogUnsubmittedIssues, componentProps: { amount } })
}

export function showFeedback(overwriteFeedbackData?: FeedbackType) {
  const supportStore = useSupportStore()
  const feedbackData = overwriteFeedbackData || supportStore.feedback

  return Dialog.create({
    component: SfxDialogFeedback,
    componentProps: { context: feedbackData.context, designation: feedbackData.designation },
  })
}

export async function showWelcomeDialog(technician: boolean) {
  const { t } = i18n.global
  const userStore = useUserStore()

  const content = technician
    ? t("sfxDialogHelp.text_technician_welcome", { company: LABELS.COMPANY })
    : t("sfxDialogHelp.text_manager_welcome", { company: LABELS.COMPANY })

  await messageDialog({
    title: t("sfxDialogHelp.title_welcome", { product: LABELS.PRODUCT }),
    content: content,
    buttonText: t("sfxButtons.btn_lets_go"),
    html: true,
  }).then(() => {
    userStore.helpDialogShown = true
  })
}

//endregion

//region Dialogs with lists

export async function attachmentListDeleteDialog(
  entity: string, // Translated entity
  attachments: Attachment[]
): Promise<boolean | undefined> {
  return promisifyDialogChainObject(
    Dialog.create({
      component: SfxDialogListAttachmentDelete,
      componentProps: { entity, attachments },
    })
  )
}

export async function attachmentListSelectDialog(
  entity: string, // Translated entity
  entityDesignation: string,
  attachmentList: Attachment[]
): Promise<Attachment | undefined | null> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogListAttachmentSelect,
      componentProps: { entity, entityDesignation, attachmentList },
    })
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export function identifierListDialog(
  entityName: string,
  entityId: string,
  associationType: IdentifierAssociationType,
  list: unknown[] = [] // TODO: Specify array type when we have Areas and Locations
): Promise<IdentifierActionReturn<IdentifierAdd | IdentifierRemove> | null> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogListIdentifier,
      componentProps: { entityName, entityId, associationType, list },
    })
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export function workOrderListDialog(
  associationType: AssociationType,
  workOrders: WorkOrderCardData[],
  entityId: string,
  entityName: string
) {
  Dialog.create({
    component: SfxDialogListWorkOrder,
    componentProps: { associationType, workOrders, entityId, entityName },
  })
}

// TODO: Maybe send whole entity and just have a type guard inside for item/area?
export function issueListDialog(
  associationType: IssueAssociationType,
  entity: IssueEntity,
  list: IssuesOnItem[] = [],
  areUnsavedChanges: boolean = false
) {
  const onDismiss = (action: () => void) => {
    if (areUnsavedChanges) {
      unsavedChangesDialog().then((userConfirmed) => {
        if (userConfirmed) {
          action()
        }
      })
    }
  }

  return Dialog.create({
    component: SfxDialogListIssue,
    componentProps: { associationType, entity, list, areUnsavedChanges, onDismiss },
  })
}

export function issueListManagerDialog(list: IssuesOnItem[] = []) {
  return Dialog.create({
    component: SfxDialogListIssueManager,
    componentProps: { list },
  })
}

export function unsubmittedWorkIssueListDialog(
  entityId: string,
  issueList: PayloadEntity<Issue>[],
  workOrderId?: string
) {
  return Dialog.create({
    component: SfxDialogListUnsubmittedWorkIssues,
    componentProps: { entityId, issueList, workOrderId },
  })
}

export function unsubmittedWorkListDialog(
  unsubmittedWorkList: UnsubmittedWorkWithEntity[],
  entity: UnsubmittedWorkEntity
) {
  return Dialog.create({
    component: SfxDialogListUnsubmittedWork,
    componentProps: { unsubmittedWorkList, entity },
  })
}

export async function workOrderListSelectDialog(
  entityType: EntityPages,
  entityId: string,
  entityDesignation: string,
  workOrders: WorkOrderCardData[]
): Promise<WorkOrderCardData> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogListWorkOrderSelect,
      componentProps: { entityType, entityId, entityDesignation, workOrders },
    }).onOk((payload) => resolve(payload))
  )
}

export async function closeIssueNotCorrectedDialog() {
  const { t } = i18n.global

  const dialogOptions: InputDialogOptions = {
    title: t("sfxDialogCloseIssueNotCorrected.title"),
    content: t("sfxDialogCloseIssueNotCorrected.content"),
    label: t("sfxDialogCloseIssueNotCorrected.label"),
    confirmButtonText: t("sfxButtons.btn_close_it"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    confirmButtonClasses: "bg-negative text-white",
    inputRequired: true,
    html: true,
  }

  return await inputDialog(dialogOptions)
}

export async function closeIssueCorrectedDialog() {
  const { t } = i18n.global

  const dialogOptions: InputDialogOptions = {
    title: t("sfxDialogCloseIssueCorrected.title"),
    content: t("sfxDialogCloseIssueCorrected.content"),
    label: t("sfxDialogCloseIssueCorrected.label"),
    confirmButtonText: t("sfxButtons.btn_close_it"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
  }

  return await inputDialog(dialogOptions)
}

export async function supersedeIssueDialog() {
  const { t } = i18n.global

  const dialogOptions: ConfirmationDialogOptions = {
    title: t("sfxDialogSupersedeIssue.title"),
    content: t("sfxDialogSupersedeIssue.content"),
    confirmButtonText: t("sfxButtons.btn_supersede"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    confirmButtonClasses: "bg-negative text-white",
    html: true,
  }

  return await confirmationDialog(dialogOptions)
}

export async function relatedUnsubmittedWorkDialog() {
  const { t } = i18n.global

  const dialogOptions: ConfirmationDialogOptions = {
    title: t("sfxDialogRelatedUnsubmittedWork.title"),
    content: t("sfxDialogRelatedUnsubmittedWork.content"),
    confirmButtonText: t("sfxButtons.btn_resume"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    confirmButtonClasses: "text-white",
    html: true,
  }

  return await confirmationDialog(dialogOptions)
}

//endregion

//region Error dialogs

// TODO: Update me once we handle problems with authentication in the submit queue
/**
 * THIS IS TEMPORARY DIALOG UNTIL WE HANDLE THIS IN THE SUBMIT QUEUE!
 * Trigger the Dialog which indicates an authentication error.
 */
export async function authenticationErrorDialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogAuthenticationError))
}

/**
 * Trigger the dialog which indicate that there are no workspaces to show
 */
export async function noWorkspacesErrorDialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogNoWorkspaces))
}

/**
 * Trigger the dialog which indicate that the app is offline
 */
export async function offlineErrorDialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogOffline))
}

export async function showHTTP400Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp400))
}

export async function showHTTP401Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp401))
}

export async function showHTTP403Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp403))
}

export async function showHTTP404Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp404))
}

export async function showHTTP408Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp408))
}

export async function showHTTP500Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp500))
}

export async function showHTTP501Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp501))
}

export async function showHTTP502Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp502))
}

export async function showHTTP503Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp503))
}

export async function showHTTP504Dialog(): Promise<boolean | undefined> {
  return promisifyDialogChainObject(genericCommonDialogCreator(SfxDialogHttp504))
}

//endregion

//region Notification dialogs

/**
 * Displays a notification message with Undo action
 *
 * @param msg Custom message to display.
 * @param callbackFn  Function to be executed when the Undo button is clicked
 * @param callbackDismissFn Function to be executed when the dialog is dismissed
 *
 * Please note that the callbackDismissFn would be executed regardless the user clicking the Undo button
 */
export function undoNotificationDialog(
  msg: string,
  callbackFn: (...args: unknown[]) => void | Promise<void>,
  callbackDismissFn?: (...args: unknown[]) => unknown | Promise<unknown>
) {
  return Dialog.create({
    component: SfxDialogUndoNotification,
    componentProps: { msg, callbackFn, callbackDismissFn },
  })
}

//endregion

//region Manager mode dialogs

/**
 * Used to open the User settings dialog in manager mode
 *
 * **NOTE**
 * This dialog is temporary.
 * Use this dialog until the SA is finished with the design of `29 - My Home (User profile and settings`)
 */
export function userSettingsDialog() {
  return Dialog.create({
    component: SfxDialogUserSettings,
  })
}

export function changePasswordDialog() {
  return Dialog.create({
    component: SfxDialogChangePassword,
  })
}

export function changeUnlockKeyDialog() {
  return Dialog.create({
    component: SfxDialogChangeUnlockKey,
  })
}

export function editCorrectionInfoDialog(
  issueId: string,
  issueOnItemAction?: IssuesOnItemAction
): Promise<IssuesOnItemAction | null> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogEditCorrectionInfo,
      componentProps: { issueId, issueOnItemAction },
    })
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export function rejectedCorrectiveWorkDialog(issueEventCard: IssueCorrectiveWorkRejectedEventCard) {
  return Dialog.create({
    component: SfxDialogRejectedCorrectiveWork,
    componentProps: { issueEventCard },
  })
}

export async function rejectIssueDialog() {
  const { t } = i18n.global

  const dialogOptions: InputDialogOptions = {
    title: t("sfxDialogRejectIssue.title"),
    content: t("sfxDialogRejectIssue.content"),
    label: t("sfxDialogRejectIssue.input_label"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    confirmButtonText: t("sfxButtons.btn_reject_it"),
    confirmButtonClasses: "bg-negative text-white",
    inputRequired: true,
    html: true,
  }

  return await inputDialog(dialogOptions)
}

export async function acceptPerformedWorkDialog() {
  const { t } = i18n.global

  const dialogOptions: InputDialogOptions = {
    title: t("sfxDialogAcceptWork.title"),
    content: t("sfxDialogAcceptWork.content"),
    label: t("sfxDialogAcceptWork.input_label"),
    confirmButtonText: t("sfxButtons.btn_confirm"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
  }
  return await inputDialog(dialogOptions)
}

export function acceptCorrectiveWorkDialog(): Promise<SfxDialogCheckedAndInput | null> {
  return new Promise((resolve) =>
    Dialog.create({ component: SfxDialogAcceptCorrectiveWork })
      .onOk((payload: SfxDialogCheckedAndInput) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export function rejectPerformedWorkDialog(
  withIssues?: boolean
): Promise<SfxDialogCheckedAndInput | null> {
  return new Promise((resolve) =>
    Dialog.create({ component: SfxDialogRejectPerformedWork, componentProps: { withIssues } })
      .onOk((payload: SfxDialogCheckedAndInput) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export async function rejectCorrectiveWorkDialog() {
  const { t } = i18n.global

  const dialogOptions: InputDialogOptions = {
    title: t("sfxDialogRejectCorrectiveWork.title"),
    content: t("sfxDialogRejectCorrectiveWork.content"),
    label: t("sfxDialogRejectCorrectiveWork.input_label"),
    confirmButtonText: t("sfxButtons.btn_reject_it"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    confirmButtonClasses: "bg-negative",
    width: 449,
    inputRequired: true,
    html: true,
  }
  return await inputDialog(dialogOptions)
}

export async function unsavedWorkOrderDraftDialog() {
  const { t } = i18n.global

  const confirmationDialogOption: ConfirmationDialogOptions = {
    title: t("sfxDialogUnsavedWorkOrderDraft.title"),
    content: t("sfxDialogUnsavedWorkOrderDraft.content"),
    confirmButtonText: t("sfxButtons.btn_confirm"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
  }
  return await confirmationDialog(confirmationDialogOption)
}

export async function addCommentDialog(
  entity: EntityPages,
  entityId: string,
  attachmentContext: AttachmentContext
): Promise<
  | IssueComment
  | PerformedWorkComment
  | WorkOrderCorrectiveItemComment
  | WorkOrderRegularItemComment
  | null
> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogAddComment,
      componentProps: { entity, entityId, attachmentContext },
    })
      .onOk((payload) => resolve(payload))
      .onCancel(() => resolve(null))
  )
}

export async function workMustBeReviewedDialog(operation: OperationsOnIssue) {
  const { t } = i18n.global
  let translatedOperation = ""

  switch (operation) {
    case "reject":
      translatedOperation = t("sfxDialogWorkMustBeReviewed.rejected")
      break
    case "delete":
      translatedOperation = t("sfxDialogWorkMustBeReviewed.deleted")
      break
    case "supersede":
      translatedOperation = t("sfxDialogWorkMustBeReviewed.superseded")
      break
    default:
      translatedOperation = t("sfxDialogWorkMustBeReviewed.closed")
  }

  return await messageDialog({
    title: t("sfxDialogWorkMustBeReviewed.title"),
    content: t("sfxDialogWorkMustBeReviewed.body_content", { operation: translatedOperation }),
    buttonText: t("sfxButtons.btn_understood_without_exclamation"),
    html: true,
  })
}

export async function closeWorkOrderCompletedDialog() {
  const { t } = i18n.global

  const dialogOptions: CheckBoxDialogOptions = {
    title: t("sfxDialogCloseWorkOrderCompleted.title"),
    content: t("sfxDialogCloseWorkOrderCompleted.content"),
    label: t("sfxDialogCloseWorkOrderCompleted.label"),
    confirmButtonText: t("sfxButtons.btn_close_it"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    html: true,
  }

  return await checkBoxDialog(dialogOptions)
}

export async function closeWorkOrderNotCompletedDialog() {
  const { t } = i18n.global

  const dialogOptions: InputDialogOptions = {
    title: t("sfxDialogCloseWorkOrderNotCompleted.title"),
    content: t("sfxDialogCloseWorkOrderNotCompleted.content"),
    label: t("sfxDialogCloseWorkOrderNotCompleted.label"),
    confirmButtonText: t("sfxButtons.btn_close_it"),
    rejectButtonText: t("sfxButtons.btn_cancel"),
    classes: "sfx-dialog-border-warning",
    titleClass: "text-negative",
    confirmButtonClasses: "bg-negative text-white",
    inputRequired: true,
    html: true,
  }

  return await inputDialog(dialogOptions)
}

export function confirmWorkOrderEntitiesModification(
  entitiesRemoved: number,
  entitiesAdded: number,
  entitiesToDo: number,
  entitiesTotal: number,
  entity: EntityPages
): Promise<boolean> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogWorkOrderEntities,
      componentProps: { entitiesRemoved, entitiesAdded, entitiesToDo, entitiesTotal, entity },
    })
      .onOk(() => resolve(true))
      .onCancel(() => resolve(false))
  )
}

export function confirmRemoveIssueFromWorkOrderDialog(
  workOrder: WorkOrderCardData
): Promise<boolean> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogRemoveIssueFromWorkOrder,
      componentProps: { workOrder },
    })
      .onOk(() => resolve(true))
      .onCancel(() => resolve(false))
  )
}

export function confirmRemoveItemFromWorkOrderDialog(
  workOrder: WorkOrderCardData
): Promise<boolean> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogRemoveItemFromWorkOrder,
      componentProps: { workOrder },
    })
      .onOk(() => resolve(true))
      .onCancel(() => resolve(false))
  )
}

export function removeItemFromWorkOrderDialog(item: ItemCardData): Promise<boolean> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogWorkOrderRemoveItem,
      componentProps: { item },
    })
      .onOk(() => resolve(true))
      .onCancel(() => resolve(false))
  )
}

export function removeIssueFromWorkOrderDialog(issue: IssueCardData): Promise<boolean> {
  return new Promise((resolve) =>
    Dialog.create({
      component: SfxDialogWorkOrderRemoveIssue,
      componentProps: { issue },
    })
      .onOk(() => resolve(true))
      .onCancel(() => resolve(false))
  )
}

//endregion
